import { ReactElement } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { Box, Checkbox, FormControlLabel, Stack } from '@mui/material'
import { CentimeterField } from '@ui/forms'
import { compactCheckboxSx, growFieldInnerSx, growFieldSx } from '../constants'

/**
 * Overhang staged for every support. Unchecked = no explicit overhang (each
 * support keeps its own state), checked = one overhang for all supports.
 */
const SharedSupportOverhangField = (): ReactElement => {
  const { setValue } = useFormContext()
  const overhang: Overhang | null | undefined = useWatch({ name: 'sharedSettings.overhang' })

  return (
    <Stack direction="column" spacing={1}>
      <FormControlLabel
        control={
          <Checkbox
            size="small"
            sx={compactCheckboxSx}
            checked={overhang != null}
            data-cy="support-compression-overhang-checkbox"
            onChange={(_event, checked) =>
              setValue(
                'sharedSettings.overhang',
                checked ? { left: 0, right: 0, front: 0, back: 0 } : null,
                { shouldDirty: true, shouldTouch: true },
              )
            }
          />
        }
        label="angeben"
        sx={{ margin: 0 }}
      />
      {overhang != null && (
        <Stack direction="column" spacing={1}>
          <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap" alignItems="center">
            <Box sx={growFieldSx(64)}>
              <CentimeterField
                inputLabel="Links"
                name="sharedSettings.overhang.left"
                sx={growFieldInnerSx}
                data-cy="support-compression-overhang-left"
              />
            </Box>
            <Box sx={growFieldSx(64)}>
              <CentimeterField
                inputLabel="Rechts"
                name="sharedSettings.overhang.right"
                sx={growFieldInnerSx}
                data-cy="support-compression-overhang-right"
              />
            </Box>
          </Stack>
          <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap" alignItems="center">
            <Box sx={growFieldSx(64)}>
              <CentimeterField
                inputLabel="Vorne"
                name="sharedSettings.overhang.front"
                sx={growFieldInnerSx}
                data-cy="support-compression-overhang-front"
              />
            </Box>
            <Box sx={growFieldSx(64)}>
              <CentimeterField
                inputLabel="Hinten"
                name="sharedSettings.overhang.back"
                sx={growFieldInnerSx}
                data-cy="support-compression-overhang-back"
              />
            </Box>
          </Stack>
        </Stack>
      )}
    </Stack>
  )
}

export default SharedSupportOverhangField
